<template>
  <BaseTable
    :isLoading="isLoading"
    :tableData="data"
    :totalItemsCount="totalItemsCount"
    :perPage="perPage"
    :currentPage="currentPage"
    :showSearch="false"
    :showCreateButton="rolPermissions.isAllowedCreate"
    createLabel="New Department"
    @create="$emit('openModal')"
    @paginate="paginate"
  >
    <template #columns>
      <Column field="name" header="Name" :styles="{ 'min-width': '10rem' }">
        <template #body="{ data }">
          <p>{{ data.department_name }}</p>
        </template>
      </Column>
      <Column field="company" header="Company" :styles="{ 'min-width': '10rem' }">
        <template #body="{ data }">
          {{ data.company_name }}
          <p v-if="data.company_name === null">All</p>
        </template>
      </Column>
    </template>

    <template #actions-column>
      <Column v-if="!rolPermissions.noActions" header="Actions">
        <template #body="{ data }">
          <div class="data-table__actions">
            <span v-if="rolPermissions.isAllowedEdit" @click="$emit('openModal', data)">
              <i class="pi pi-pencil"></i>
            </span>
            <span v-if="rolPermissions.isAllowedDelete" @click="deleteRow(data)">
              <i class="pi pi-trash"></i>
            </span>
          </div>
        </template>
      </Column>
    </template>
  </BaseTable>
</template>

<script>
import { mapGetters } from "vuex";
import { successMessage, deleteMessage } from "@/utils/alertMessages";
import { rolPermissions } from "@/mixins/itemsTable/infoUser";
import BaseTable from "./BaseTable.vue";

export default {
  name: "DepartmentTable",
  components: { BaseTable },
  props: ["firstPage"],
  emits: ["openModal"],
  data() {
    return {
      isLoading: false,
      data: [],
      loggedUser: null,
      rolPermissions: {},
      confirmationDeleteMessage: "I'm sure I want to delete this",
      totalItemsCount: 0,
      currentPage: 1,
      perPage: 15,
    };
  },
  computed: {
    ...mapGetters("user", ["showCurrentCompanyDepartment"]),
  },
  watch: {
    async showCurrentCompanyDepartment() {
      if (this.showCurrentCompanyDepartment) {
        this.currentPage = 1;
        this.getUserPermissions();
        await this.getdepartments();
      }
    },
    firstPage() {
      this.currentPage = 1;
    },
  },
  async created() {
    this.loggedUser = JSON.parse(localStorage.getItem("user-info"));
    this.getUserPermissions();
    await this.getdepartments();
  },
  methods: {
    getUserPermissions() {
      this.rolPermissions = rolPermissions(this.loggedUser, "Department");
    },
    async getdepartments() {
      this.isLoading = true;
      const params = {};
      if (this.loggedUser.role === "global_admin") {
        params.company_id = -2;
        params.department_id = -2;
      } else if (this.loggedUser.role === "company_admin") {
        params.company_id = this.loggedUser.company_id;
        params.department_id = -2;
      } else if (this.loggedUser.role === "department_admin") {
        params.company_id = this.loggedUser.company_id;
        params.department_id = this.loggedUser.company_info[0].departments[0].id;
      }
      params.limit = 15;
      params.skip = (this.currentPage - 1) * 15;
      const info = await this.$store.dispatch("company/getDepartmentsPerCompany", params);
      this.data = info.data;
      this.totalItemsCount = info.count;
      this.isLoading = false;
    },
    async paginate(page) {
      this.currentPage = page;
      this.getUserPermissions();
      await this.getdepartments();
      window.scrollTo(0, 0);
    },
    async deleteRow(deptData) {
      const msg = "Are you sure you want to remove Department from the system?";
      const warningResponse = await deleteMessage(msg, "You won't be able to revert this!");
      if (warningResponse.isConfirmed) {
        const params = {
          department_id: deptData.department_id,
          confirmation_message: this.confirmationDeleteMessage,
        };
        const response = await this.$store.dispatch("department/deleteDepartment", params);
        if (response.status === 200 || response.status === 204) {
          successMessage("The department has been deleted.");
          if (this.data.length === 1 && this.currentPage > 1) this.currentPage -= 1;
          await this.getdepartments();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include table-action-icons;
</style>
